﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadRepresentationField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadRepresentationField, eOutputFieldType.cadRepresentation)
export class CadRepresentationField extends OutputField implements ICadRepresentationField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public parentComponentID: string;
    public visibility: boolean;
}
